export default {
  benefits: {
    earn_points: 'Earn points with every order',
    get_deals: 'Receive exclusive discounts',
    redeem_points: 'Redeem points for free food',
  },
};
